import { Component } from '@angular/core';
import { AuthService } from '@core/auth';
import { Tooltip } from 'bootstrap';
import { ActiveConsultationStateService } from './consultations';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    standalone: false,
    styleUrl: './app.component.css'
})
export class AppComponent {
    hasAuth: boolean;

    constructor(private authService: AuthService, private activeConsultationState: ActiveConsultationStateService) {
        this.hasAuth = !!this.authService.token && !!this.authService.user;
        if (this.hasAuth) this.activeConsultationState.startPolling();

        this.authService.hasAuthentication().subscribe((user: any) => {
            this.hasAuth = !!user;
            if (this.hasAuth) this.activeConsultationState.startPolling();
            else this.activeConsultationState.stopPolling();
        });

        new Tooltip(document.body, {
            selector: '[data-bs-toggle="tooltip"]',
            container: 'body',
            placement: 'top',
            trigger: 'hover',
        });
    }
}
